/**
 * useBatchImportInvoices - Hook pour l'import batch de factures clients (migration)
 *
 * Pattern: Component → Hook (useMutation) → Service (batchOCRAPI)
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { batchOCRAPI } from '@/utils/api';
import { notifications } from '@/lib/notifications';
import { getErrorMessage } from '@/lib/errorHandler';

const INVOICES_KEY = ['invoices'];

export interface BatchInvoiceLineItem {
  description: string;
  quantity: number;
  unitPrice: number;
  taxPercent: number;
}

export interface BatchInvoiceData {
  clientName?: string;
  clientSiret?: string;
  invoiceNumber?: string;
  issueDate: string;
  dueDate?: string;
  totalHT: number;
  taxRate: number;
  totalTTC?: number;
  lineItems?: BatchInvoiceLineItem[];
  status: 'DRAFT' | 'PAID';
}

export function useBatchImportInvoices() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (invoices: BatchInvoiceData[]) => batchOCRAPI.batchImportInvoices(invoices),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: INVOICES_KEY });
      const succeeded = result.succeeded || 0;
      const total = result.total || 0;
      notifications.success(`${succeeded}/${total} factures importées`);
    },
    onError: (error: Error) => {
      notifications.error(getErrorMessage(error));
    },
  });
}
